<!-- 需方商品管理总页面 -->
<template>
  <div id="appid" class="app-container classification">
    <div class="top-search">
      <header class="search-title">
        <span class="title-text">商品分类</span>
      </header>
    </div>
    <!--左侧条件-->
    <div class="bigBox">
      <div class="left-condition">
        <div class="condition-conton">
          <div class="con-header">
            <div>
              <span class="branch" />
              <span class="query">查询</span>
            </div>
            <div class="right">《</div>
          </div>
          <div class="con-con">
            <div class="confirm">确认状态：</div>
            <div class="con-select">
              <el-select v-model="pageLIst.accepted" placeholder="请选择" @change="valueChange">
                <!-- <el-option lable="全部" value=""></el-option> -->
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="condition">
              <el-input v-model="filterText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="tree"
                class="filter-tree"
                :data="datasele"
                :props="defaultProps"
                default-expand-all
                :filter-node-method="filterNode"
                @node-click="handleTreeNodeClick"
              />
            </div>
          </div>
        </div>
      </div>
      <!--右侧表格-->
      <div class="right-table">
        <el-form ref="form" class="commodity-form" :model="sizeForm" label-width="60px" size="mini">
          <el-button v-if="rols('新增')" class="form-button" @click="dialogAdd()">新增</el-button>
          <el-button v-if="rols('修改')" class="form-button" @click="modifyData()">修改</el-button>
          <el-button v-if="rols('删除')" class="form-button" @click="centDel()">删除</el-button>
          <el-button v-if="rols('确认')" class="form-button" @click="DialogConfirm()">确认</el-button>
        </el-form>
        <div class="bottom-table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            fit
            :header-cell-style="{
              background: '#F3F3F3',
              color: '#202020',
              textAlign: 'center',
              fontSize: '14px',
            }"
            :cell-style="{ textAlign: 'center' }"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column type="selection" width="55" />
            <el-table-column prop="FName" label="节点名称" />
            <el-table-column prop="FLevelName" show-overflow-tooltip label="层级" />
            <el-table-column prop="FShortCode" label="简码" show-overflow-tooltip />
            <el-table-column prop="FAccepter" label="确认人" show-overflow-tooltip />
            <el-table-column prop="FAcceptDate" label="确认时间" show-overflow-tooltip />
          </el-table>
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageLIst.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />

          <!-- <el-pagination
            class="commodity-pagination"
            background
            :page-size="pageSize"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          /> -->
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog center title="新增商品分类" :visible.sync="dialogFormVisibleAdd">
      <el-form :model="formadd">
        <el-form-item label="层级名称" :label-width="formLabelWidth">
          <el-input v-model="formadd.id" disabled="disabled" autocomplete="off" />
        </el-form-item>
        <el-form-item label="节点名称" :label-width="formLabelWidth">
          <el-input v-model="formadd.name" autocomplete="off" />
        </el-form-item>
      </el-form>
      <el-checkbox v-model="checked">继续下一条</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleAdd = false">取 消</el-button>
        <el-button type="primary" @click="adddata()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog center title="修改商品分类" :visible.sync="dialogFormVisibleModify">
      <el-form :model="formMod">
        <el-form-item label="层级名称" :label-width="formLabelWidth">
          <el-input v-model="formMod.name" disabled="disabled" autocomplete="off" />
        </el-form-item>
        <el-form-item label="节点名称" :label-width="formLabelWidth">
          <el-input v-model="formMod.nameNode" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleModify = false">取 消</el-button>
        <el-button type="primary" @click="dialoModify()">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog title="删除商品分类" :visible.sync="centerDialogVisibleDel" width="30%" center>
      <img src="@/assets/images/imgdoubt.png" alt="">
      <div>是否删除该商品分类</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisibleDel = false">取 消</el-button>
        <el-button type="primary" @click="delData()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确认 -->
    <el-dialog title="确认商品分类" :visible.sync="centerDialogVisibleConfirm" width="30%" center>
      <img src="@/assets/images/imgdoubt.png" alt="">
      <div>是否确认该商品分类有效</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisibleConfirm = false">取 消</el-button>
        <el-button type="primary" @click="dialogCon">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确认点击删除 -->
    <el-dialog title="无法删除商品分类" :visible.sync="centerDialogVisibleConfirmDel" width="30%" center>
      <img src="@/assets/images/delcom.png" alt="">
      <div>该商品分类已确认，无法删除。</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisibleConfirmDel = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisibleConfirmDel = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassData,
  getAddData,
  getTreeData,
  getModData,
  getConfirm,
  getDel
} from '@/api/classification'
export default {
  data() {
    return {
      checked: false,
      formadd: {
        id: null,
        name: ''
      },
      formMod: {
        id: null,
        name: ''
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      gridData: [],
      dialogFormVisibleModify: false,
      dialogFormVisibleModify: false,
      filterText: '',
      datasele: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      conditionInput: '',
      options: [{
        value: -1,
        label: '全部'
      },
      {
        value: 0,
        label: '未确认'
      },
      {
        value: 1,
        label: '已确认'
      }
      ],
      valueSele: '',
      stockFID: '',
      requesUrl: '',
      title: '',
      list: null,
      loading: false,
      listLoading: true,
      currentPage: 1,
      // pageSize: 2,
      total: 0,
      sizeForm: {
        FMarkID: '',
        FMarkName: '',
        FStockClassID: '',
        FStockClassName: '',
        StockFID: '',
        StockName: ''
      },
      pageLIst: {
        pageNo: 1,
        pageSize: 10,
        fStoreClassId: 0,
        mallStoreId: 0,
        accepted: -1,
        queryType: 2
      },
      tableData: [],
      multipleSelection: [],
      centerDialogVisibleDel: false,
      centerDialogVisibleConfirm: false,
      dialogFormVisibleAdd: false,
      centerDialogVisibleConfirmDel: false,
      num: 1,
      treeData: [],
      fid: '',
      addfiData: {
        fid: '',
        flevelname: ''
      },
      dataStr: ''
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('商品分类')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    this.valueChange()
  },
  created() {
    this.$nextTick(() => {
      this.getInitData()
    })
    this.getTree()
  },
  methods: {
    valueChange(val) {
      this.accepted = val
    },
    // 删除确认按钮
    delData() {
      getDel({
        fStoreClassIds: this.dataStr,
        operationType: 2
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.centerDialogVisibleDel = false
          this.getTree()
          this.getInitData()
        }
      })
    },
    // 确认打开弹框
    DialogConfirm() {
      for (let index = 0; index < this.multipleSelection.length; index++) {
        if (this.multipleSelection[index].FAccepted) {
          this.$message({
            message: '选择的数据中已有确认',
            type: 'warning'
          })
          break
        } else {
          this.centerDialogVisibleConfirm = true
        }
      }
    },
    modifyData() {
      this.dialogFormVisibleModify = true
      this.formMod.name = this.addfiData.flevelname
      this.formMod.id = this.addfiData.fid
    },
    // 修改保存按钮
    dialoModify() {
      const data = {
        FStoreClassId: this.formMod.id,
        FName: this.formMod.nameNode
      }
      if (this.formMod.name == '') {
        this.$message({
          message: '请选择一个层级',
          type: 'warning'
        })
        return
      } else {
        getModData({
          jsonobj: data
        }).then((res) => {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.getTree()
          this.getInitData()
        })
      }

      this.dialogFormVisibleModify = false
    },
    handleTreeNodeClick(data, node, elem) {
      this.addfiData.fid = data.fid
      this.addfiData.flevelname = data.fname
      this.pageLIst.fStoreClassId = data.fid
      this.pageLIst.pageNo = 1
      this.getInitData(data.fid)
    },
    // 查询表格数据
    getInitData() {
      getClassData({
        pageNo: this.pageLIst.pageNo,
        pageSize: this.pageLIst.pageSize,
        fStoreClassId: this.pageLIst.fStoreClassId,
        mallStoreId: this.pageLIst.mallStoreId,
        accepted: this.pageLIst.accepted,
        queryType: this.pageLIst.queryType
      }).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    // 新增功能 打开遮罩
    dialogAdd() {
      this.formadd.name = ''
      this.formadd.id = this.addfiData.flevelname
      this.dialogFormVisibleAdd = true
    },
    // 新增确定按钮
    adddata() {
      const data = {
        FLevelId: this.addfiData.fid,
        FName: this.formadd.name
      }
      if (this.formadd.id == '') {
        this.$message({
          message: '请选择一个层级',
          type: 'warning'
        })
        return
      } else {
        if (this.checked == true) {
          getAddData({
            jsonobj: data
          }).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.formadd.name = ''
            this.getTree()
            this.getInitData()
          })
        } else {
          getAddData({
            jsonobj: data
          }).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.dialogFormVisibleAdd = false
            this.getTree()
            this.getInitData()
          })
        }
      }
    },
    // 获取树形控件数据
    getTree() {
      getTreeData({
        keyword: this.filterText
      }).then((res) => {
        this.toTree(res.rows)
      })
    },
    toTree(data) {
      const obj = {} // 使用对象重新存储数据
      const res = [] // 存储最后结果
      const len = data.length
      // 遍历原始数据data，构造obj数据，键名为id，值为数据
      for (let i = 0; i < len; i++) {
        data[i].label = data[i].fname
        obj[data[i]['fid']] = data[i]
      }

      // 遍历原始数据
      for (let j = 0; j < len; j++) {
        const list = data[j]
        // 通过每条数据的 pid 去obj中查询
        const parentList = obj[list['fparentid']]

        if (parentList) {
          // 根据 pid 找到的是父节点，list是子节点，
          if (!parentList['children']) {
            parentList['children'] = []
          }
          // 将子节点插入 父节点的 children 字段中
          parentList['children'].push(list)
        } else {
          // pid 找不到对应值，说明是根结点，直接插到根数组中
          res.push(list)
        }
      }
      this.datasele = res
    },
    // 点击确认调用接口按钮
    dialogCon() {
      getConfirm({
        fStoreClassIds: this.dataStr
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
        this.getTree()
        this.getInitData()
      })
      this.num = 2
      this.centerDialogVisibleConfirm = false
    },
    centDel() {
      this.multipleSelection.forEach((item) => {
        if (item.FAccepted) {
          this.centerDialogVisibleConfirmDel = true
          this.centerDialogVisibleDel = false
        } else {
          this.centerDialogVisibleDel = true
          this.centerDialogVisibleConfirmDel = false
        }
      })
    },
    modify() {},
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleSelectionChange(val) {
      const dataId = []
      // if (val.length > 1) {
      val.map((item) => {
        dataId.push(item.FID)
      })
      this.dataStr = dataId.join(',')
      // }else {}
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.pageLIst.pageNo = val
      this.getInitData()
    },
    handleCurrentChange(val) {
      this.pageLIst.pageNo = val
      this.getInitData()
    }
  }
}
</script>
<style lang="scss" scoped>
    li {
        list-style-type: none;
    }

    .app-container {
        background: #ffffff;
        padding: 8px;
        height: 100%;
        display: flex;
        flex-direction: column;

        .iconBox {
            width: 35px;
            height: 35px;
        }

        .commodity-form {
            display: flex;
            margin: 10px 10px;

            .first-button {
                background-color: #ec212d;
                color: #fff;
                margin: 0 62px 0 10px;
            }
        }

        .search-title {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 36px;
            line-height: 36px;
            background-color: #ec212d;

            .title-text {
                color: #fff;
                font-size: 16px;
                margin-left: 11px;
            }
        }

        .top-search {
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .form-button {
            // width: 175px;
            height: 24px;
            font-size: 12px;
            line-height: 0;
            color: #ec212d;
            background: #fff;
            border: 1px solid #ec212d;
            border-radius: 4px;
            padding: 0 10px;
        }

        .bigBox {
            margin-top: 10px;

            .left-condition {
                float: left;
                width: 192px;
                height: 700px;
                background: #fff2eb;

                .condition-conton {
                    width: 100%;

                    .con-header {
                        margin: 9px 14px 0px 4px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .branch {
                            height: 14px;
                            border-right: 3px solid #ec212d;
                        }

                        .query {
                            height: 14px;
                            font-size: 14px;
                            font-family: PingFang SC;
                            font-weight: 500;
                            color: #333333;
                            margin-left: 8px;
                        }

                        .right {
                            width: 6px;
                            color: #ec212d;
                        }
                    }

                    .con-con {
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                        margin: 11px 10px 6px 0px;

                        .confirm {
                            display: inline-block;
                        }

                        .con-select {
                            display: inline-block;
                            width: 122px;
                            height: 24px;
                            background: #ffffff;
                            border: 1px solid #e6e6e6;
                            border-radius: 4px;
                        }

                        .condition {
                            margin: 6px 10px 0px 8px;
                        }
                    }
                }
            }

            .right-table {
                // height: 100%;
                padding: 0 10px;
                overflow: hidden;
                // float: left;
                position: relative;

                .commodity-pagination {
                    text-align: center;
                    margin-top: 10px;
                }
            }
        }

        .bottom-table {
            // height: 500px;
            height: 88%;
        }

        .operation-icon {
            width: 16px;
            height: 16px;
            margin-right: 15px;
            cursor: pointer;
        }

        .one-icon {
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }
</style>
<style lang="scss">
    .classification {
        .commodity-form {
            .el-input__suffix {
                right: 10px;
            }
        }

        .commodity-form {
            .el-form-item__content {
                margin-right: 20px;
            }
        }

        // .el-select-dropdown__item.selected {
        //   color: #1b7469 !important;
        // }
        .top-search {
            .el-form-item__label {
                font-size: 12px;
                padding: 0 7px 0 0;
            }

            .el-input__inner {
                height: 24px;
                padding: 5px;
            }

            .el-form-item {
                margin: 0;
            }

            .el-input__prefix {
                // right: 5px !important;
                // text-align: right;
                position: relative;

                .el-input__icon {
                    position: absolute;
                    right: 10px;
                }
            }

            .el-icon-d-arrow-left:before {
                color: #2db0a0;
                font-size: 10px;
                font-weight: 700;
            }

            .form-button .el-icon-search {
                margin-right: 5px;
                font-weight: 700;
            }
        }

        .right-table {
            .el-table__body-wrapper {
                height: 540px !important;
                overflow-y: auto;
            }

            .bottom-table .el-table {
                // height: 60vh;
                overflow-y: auto;
            }

            th {
                padding: 5px;
            }

            td {
                // font-size: 12px;
                padding: 5px;
                color: #202020;
            }

            .el-pagination.is-background .el-pager li {
                background: none;
                border: 1px solid #ccc;
            }

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #ec212d;
            }
        }

        .refuse-view {
            .el-dialog {
                min-height: 470px;
                overflow: hidden;
                overflow-y: scroll;
                min-width: 800px;
            }

            .el-dialog__header {
                background-color: #2db0a0;
            }

            .el-dialog__title,
            .el-dialog__close {
                color: #ffffff;
            }

            .refuse-title {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
            }

            .refuse-content {
                width: 100%;
                height: 78px;
                background: #f5f5f5;
                border: 1px solid #d2d2d2;
                box-sizing: border-box;
                padding: 10px;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                margin-top: 10px;
            }

            .refuse-content-image {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0 20px 0;

                img {
                    width: 178px;
                    height: 240px;
                    border: 1px dashed #dcdcdc;
                }
            }

            .refuse-close {
                width: 100%;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;

                .refuse-close-btn {
                    width: 135px;
                    height: 30px;
                    border: 1px solid #34bcb0;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #2db0a0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .el-select .el-input__icon {
            line-height: 24px !important;
        }

        .el-select .el-input--suffix .el-input__inner {
            height: 24px;
        }

        .condition .el-input__inner {
            height: 24px;
            background: #ffffff;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
        }

        .condition .el-tree {
            width: 100%;
            height: 585px;
            background: #ffffff;
            border: 1px solid #ec5a21;
            overflow-y: auto;
            margin-top: 8px;
            // overflow-x: auto;
            width: 100%;
            overflow-x: auto;
            white-space: nowrap;
        }

        #appid .el-dialog__body {
            text-align: center;
        }

        #appid .el-tree-node__content {
            height: 29px;
        }

        #appid .el-pagination {
            text-align: center;
            margin-top: 20px;
        }

        #appid .el-tree-node {
            // width: 200px;
        }
    }
</style>
